import { useState } from 'react';
import { apiJson } from '../api/client.js';
import { formatDateTime } from '../utils/formatDate.js';

/**
 * @param {{ projectId: string | number, approval: Record<string, any>, onUpdated?: () => void }} props
 */
export function FigmaApprovalClientPanel({ projectId, approval, onUpdated }) {
  const [comment, setComment] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  if (!approval || approval.status !== 'pending') {
    return null;
  }

  const respond = async (action) => {
    setBusy(true);
    setError('');
    try {
      await apiJson(`/api/my/projects/${projectId}/figma-approvals/${approval.id}/respond`, {
        method: 'POST',
        body: {
          action,
          comment: comment.trim() || null,
        },
      });
      setDone(true);
      onUpdated?.();
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  if (done) {
    return (
      <div className="auth-card flat" style={{ marginTop: '0.75rem', borderLeft: '3px solid var(--ok, #22c55e)' }}>
        <p style={{ margin: 0 }}>Thank you — your response was sent to the agency.</p>
      </div>
    );
  }

  return (
    <div className="auth-card flat stack" style={{ marginTop: '0.75rem', borderLeft: '3px solid var(--warn, #f59e0b)' }}>
      <div>
        <p style={{ margin: '0 0 0.25rem' }}>
          <span className="badge badge-warn">Awaiting your review</span>
        </p>
        {approval.title ? <strong>{approval.title}</strong> : <strong>Design mockup</strong>}
        {approval.staff_note ? <p className="muted small" style={{ margin: '0.5rem 0 0' }}>{approval.staff_note}</p> : null}
        <p className="muted small" style={{ margin: '0.5rem 0 0' }}>
          Sent {formatDateTime(approval.created_at)}
        </p>
      </div>

      {error ? <p className="err">{error}</p> : null}

      <label className="field">
        <span>Comments (required when requesting changes)</span>
        <textarea
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          rows={3}
          placeholder="Describe what should be changed, or leave a note with your approval."
        />
      </label>

      <div className="inline-two" style={{ gap: '0.5rem' }}>
        <button type="button" className="btn-primary" disabled={busy} onClick={() => void respond('approve')}>
          Approve
        </button>
        <button
          type="button"
          className="btn-secondary"
          disabled={busy || !comment.trim()}
          onClick={() => void respond('request_changes')}
        >
          Request changes
        </button>
      </div>
    </div>
  );
}
